// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"keyboard"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M2 4H22V20H2V4Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M2 4H22V20H2V4Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M6 16H18M5.99609 11.5H6V11.5039H5.99609V11.5ZM9.99609 11.5H10V11.5039H9.99609V11.5ZM13.9961 11.5H14V11.5039H13.9961V11.5ZM17.9961 8.5H18V8.50391H17.9961V8.5ZM17.9961 11.5H18V11.5039H17.9961V11.5ZM13.9961 8.5H14V8.50391H13.9961V8.5ZM9.99609 8.5H10V8.50391H9.99609V8.5ZM5.99609 8.5H6V8.50391H5.99609V8.5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-keyboard')
export default class KeyboardIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'keyboard',
    }
  }
}
